// Libraries
import React from "react";
import {reduxForm} from "redux-form";
import {get} from "lodash";
import {connect} from "react-redux";
import {compose} from "recompose";

// Components
import BaseForm from "components/Form/Form";
import QB from "./QB";

// Services
import {ACTION_TYPE, SESSION_TYPE, signIn} from "services/session";

const Form = (): JSX.Element => {
  const onSubmit = (values: any) => {
    console.log("values", values);
  };

  return (
    <BaseForm
      onSubmit={onSubmit}
      name="plans"
      autoComplete="off"
    >
      <QB />
    </BaseForm>
  )
};

const childQuestionnaireForm = reduxForm<object, any>({
  form: "child_questionnaire",
  touchOnChange: true,
  enableReinitialize: true
})(Form);

const mapStateToProps = (state: object): object => ({
  session: get(state, 'session'),
  genders: get(state, 'options.genders'),
  roles: get(state, 'options.roles'),
  clientsStatuses: get(state, 'options.clients_statuses'),
  formValues: get(state, 'form.user.values'),
});

const mapDispatchToProps = (dispatch: (action: ACTION_TYPE) => any) => ({
  // Services
  signIn: (user: SESSION_TYPE) => dispatch(signIn(user)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(childQuestionnaireForm);
